"use strict";
/* eslint-disable func-names, dot-notation */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* global Handsontable */
var jquery_1 = __importDefault(require("jquery"));
function initTable(id, tableOptions) {
    var containerId = id + '-handsontable-container';
    var tableHeaderCheckboxId = id + '-handsontable-header';
    var colHeaderCheckboxId = id + '-handsontable-col-header';
    var tableCaptionId = id + '-handsontable-col-caption';
    var hiddenStreamInput = jquery_1["default"]('#' + id);
    var tableHeaderCheckbox = jquery_1["default"]('#' + tableHeaderCheckboxId);
    var colHeaderCheckbox = jquery_1["default"]('#' + colHeaderCheckboxId);
    var tableCaption = jquery_1["default"]('#' + tableCaptionId);
    var finalOptions = {};
    var hot = null;
    var dataForForm = null;
    var isInitialized = false;
    var getWidth = function () {
        return jquery_1["default"]('.widget-table_input').closest('.sequence-member-inner').width();
    };
    var getHeight = function () {
        var tableParent = jquery_1["default"]('#' + id).parent();
        return tableParent.find('.htCore').height() + (tableParent.find('.input').height() * 2);
    };
    var resizeTargets = ['.input > .handsontable', '.wtHider', '.wtHolder'];
    var resizeHeight = function (height) {
        var currTable = jquery_1["default"]('#' + id);
        jquery_1["default"].each(resizeTargets, function () {
            currTable.closest('.field-content').find(this).height(height);
        });
    };
    function resizeWidth(width) {
        jquery_1["default"].each(resizeTargets, function () {
            jquery_1["default"](this).width(width);
        });
        var parentDiv = jquery_1["default"]('.widget-table_input').parent();
        parentDiv.find('.field-content').width(width);
        parentDiv.find('.fieldname-table .field-content .field-content').width('80%');
    }
    try {
        dataForForm = JSON.parse(hiddenStreamInput.val());
    }
    catch (e) {
        // do nothing
    }
    if (dataForForm !== null) {
        if (dataForForm.hasOwnProperty('first_row_is_table_header')) {
            tableHeaderCheckbox.prop('checked', dataForForm.first_row_is_table_header);
        }
        if (dataForForm.hasOwnProperty('first_col_is_header')) {
            colHeaderCheckbox.prop('checked', dataForForm.first_col_is_header);
        }
        if (dataForForm.hasOwnProperty('table_caption')) {
            tableCaption.prop('value', dataForForm.table_caption);
        }
    }
    if (!tableOptions.hasOwnProperty('width') || !tableOptions.hasOwnProperty('height')) {
        // Size to parent .sequence-member-inner width if width is not given in tableOptions
        jquery_1["default"](window).on('resize', function () {
            hot.updateSettings({
                width: getWidth(),
                height: getHeight()
            });
            resizeWidth('100%');
        });
    }
    var getCellsClassnames = function () {
        var meta = hot.getCellsMeta();
        var cellsClassnames = [];
        for (var i = 0; i < meta.length; i++) {
            if (meta[i].hasOwnProperty('className')) {
                cellsClassnames.push({
                    row: meta[i].row,
                    col: meta[i].col,
                    className: meta[i].className
                });
            }
        }
        return cellsClassnames;
    };
    var persist = function () {
        hiddenStreamInput.val(JSON.stringify({
            data: hot.getData(),
            cell: getCellsClassnames(),
            first_row_is_table_header: tableHeaderCheckbox.prop('checked'),
            first_col_is_header: colHeaderCheckbox.prop('checked'),
            table_caption: tableCaption.val()
        }));
    };
    var cellEvent = function (change, source) {
        if (source === 'loadData') {
            return; // don't save this change
        }
        persist();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var metaEvent = function (row, column, key, value) {
        if (isInitialized && key === 'className') {
            persist();
        }
    };
    var initEvent = function () {
        isInitialized = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var structureEvent = function (index, amount) {
        resizeHeight(getHeight());
        persist();
    };
    tableHeaderCheckbox.on('change', function () {
        persist();
    });
    colHeaderCheckbox.on('change', function () {
        persist();
    });
    tableCaption.on('change', function () {
        persist();
    });
    var defaultOptions = {
        afterChange: cellEvent,
        afterCreateCol: structureEvent,
        afterCreateRow: structureEvent,
        afterRemoveCol: structureEvent,
        afterRemoveRow: structureEvent,
        afterSetCellMeta: metaEvent,
        afterInit: initEvent,
        // contextMenu set via init, from server defaults
    };
    if (dataForForm !== null) {
        // Overrides default value from tableOptions (if given) with value from database
        if (dataForForm.hasOwnProperty('data')) {
            defaultOptions.data = dataForForm.data;
        }
        if (dataForForm.hasOwnProperty('cell')) {
            defaultOptions.cell = dataForForm.cell;
        }
    }
    Object.keys(defaultOptions).forEach(function (key) {
        finalOptions[key] = defaultOptions[key];
    });
    Object.keys(tableOptions).forEach(function (key) {
        finalOptions[key] = tableOptions[key];
    });
    hot = new Handsontable(document.getElementById(containerId), finalOptions);
    hot.render(); // Call to render removes 'null' literals from empty cells
    // Apply resize after document is finished loading (parent .sequence-member-inner width is set)
    if ('resize' in jquery_1["default"](window)) {
        resizeHeight(getHeight());
        jquery_1["default"](window).on('load', function () {
            jquery_1["default"](window).trigger('resize');
        });
    }
}
window.initTable = initTable;
var TableInput = /** @class */ (function () {
    function TableInput(options, strings) {
        this.options = options;
        this.strings = strings;
    }
    TableInput.prototype.render = function (placeholder, name, id, initialState) {
        var container = document.createElement('div');
        container.innerHTML = "\n      <div class=\"field boolean_field widget-checkbox_input\">\n        <label for=\"" + id + "-handsontable-header\">" + this.strings['Row header'] + "</label>\n        <div class=\"field-content\">\n          <div class=\"input\">\n            <input type=\"checkbox\" id=\"" + id + "-handsontable-header\" name=\"handsontable-header\" />\n          </div>\n          <p class=\"help\">" + this.strings['Display the first row as a header.'] + "</p>\n        </div>\n      </div>\n      <br/>\n      <div class=\"field boolean_field widget-checkbox_input\">\n        <label for=\"" + id + "-handsontable-col-header\">" + this.strings['Column header'] + "</label>\n        <div class=\"field-content\">\n          <div class=\"input\">\n            <input type=\"checkbox\" id=\"" + id + "-handsontable-col-header\" name=\"handsontable-col-header\" />\n          </div>\n          <p class=\"help\">" + this.strings['Display the first column as a header.'] + "</p>\n        </div>\n      </div>\n      <br/>\n      <div class=\"field\">\n          <label for=\"" + id + "-handsontable-col-caption\">" + this.strings['Table caption'] + "</label>\n          <div class=\"field-content\">\n            <div class=\"input\">\n            <input type=\"text\" id=\"" + id + "-handsontable-col-caption\" name=\"handsontable-col-caption\" />\n          </div>\n          <p class=\"help\">\n            " + this.strings['A heading that identifies the overall topic of the table, and is useful for screen reader users'] /* eslint-disable-line max-len */ + "\n          </p>\n        </div>\n      </div>\n      <br/>\n      <div id=\"" + id + "-handsontable-container\"></div>\n      <input type=\"hidden\" name=\"" + name + "\" id=\"" + id + "\" placeholder=\"" + this.strings['Table'] + "\">\n    ";
        placeholder.replaceWith(container);
        var input = container.querySelector("input[name=\"" + name + "\"]");
        var options = this.options;
        var widget = {
            getValue: function () {
                return JSON.parse(input.value);
            },
            getState: function () {
                return JSON.parse(input.value);
            },
            setState: function (state) {
                input.value = JSON.stringify(state);
                initTable(id, options);
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            focus: function () { },
        };
        widget.setState(initialState);
        return widget;
    };
    return TableInput;
}());
window.telepath.register('wagtail.widgets.TableInput', TableInput);
